<template>
    <div class="subtasks__add">
        <span
            v-if="!createConfirm"
            class="icon-text subtasks__add-btn"
            @click="createConfirm = {count: 1, type: null, object: (selectedStream.description_object || {}).id}"><Icon
            id="plus"/> Добавить подзадачу</span>

        <div class="subtasks__add-new" v-else>
            <div class="subtasks__add-close" @click="createConfirm = null">
                <Icon id="delete" color="purple"/>
            </div>

            <div class="subtask-new-prop">
                <Select
                    name="subtasks__add-type"
                    placeholder="Выберите тип подзадачи"
                    :items="subtaskTypes"
                    :active="createConfirm.type"
                    @selectChange="v => {
                        createConfirm.type = v;
                        errors.type = false;
                    }"
                />

                <small v-if="errors.type" style="color: red">Тип подзадачи обязателен</small>
            </div>

            <div class="subtask-new-prop subtask-new-prop_count d-flex align-items-center">
                <div class="subtask-new-prop__label">Кол-во подзадач:</div>
                <input type="text" class="form-input" style="width: 55px;" v-model="createConfirm.count">
            </div>

            <div class="subtask-new-prop subtask-new-prop_desc">
                <div class="subtask-new-prop__label">Объект:</div>

                <TaskObject
                    :activeId="createConfirm.object"
                    @setActive="v => createConfirm.object = v"
                />
            </div>

            <button class="btn btn-primary" @click.prevent="createStream">Добавить</button>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import TaskObject from "@/vue/plan/url/Task/TaskObject";

export default {
    name: "SubtasksNew",
    components: {TaskObject},
    props: ['urlTaskId'],
    data() {
        return {
            createConfirm: null,
            errors: {},
        };
    },
    computed: mapState({
        selectedStream: state => state.planUrl.selectedStream,
        subtaskTypes: state => state.planUrlNew.newTasks,
        objects: state => state.planObjects.descriptionObjects,
    }),
    methods: {
        createStream() {
            const count = Math.min(Math.max(1, +this.createConfirm.count), 99);

            if (!this.createConfirm.type) {
                this.errors = {...this.errors, type: true};
                return;
            }

            this.$store.dispatch('createPlanUrlStream', {
                taskId: this.urlTaskId,
                count,
                type: this.createConfirm.type,
                object: this.createConfirm.object,
            })
                .then(response => {
                    this.createConfirm = false;
                    this.$store.dispatch('fetchPlanUrlTaskStreamList', {taskId: this.urlTaskId});
                })
            .finally(() => {
                this.errors = {};
            })
        },
    }
}
</script>

<style lang="scss">
.subtasks {
    &__add-btn {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        line-height: 1.2;
        font-size: 14px;
        color: #30B68F;

        .icon {
            --size: 20px;
        }

        @media screen and (min-width: 1600px) {
            font-size: 16px;

            .icon {
                --size: 26px;
            }
        }
    }

    &__add {
        position: relative;
        margin-top: 40px;
        cursor: pointer;
    }

    &__add-close {
        z-index: 100;
        position: absolute;
        right: 0;
        top: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
    }

    &__add-new {
        border-top: 1px solid #30B68F;
        padding-top: 12px;
        padding-right: 30px;
    }
}

.subtask-new-prop {
    justify-content: space-between;
    align-items: center;
    margin: 0 0 12px;

    &__label {
        margin-right: 8px;
        font-size: 14px;
        font-weight: 700;
    }

    &_desc {
        .dropdown {
            max-width: 165px;
        }
    }

    @media screen and (max-width: 1600px) {
        &_desc {
            flex-wrap: wrap;

            .subtask-new-prop__label {
                margin-bottom: 5px;
            }

            .dropdown {
                width: 100%;
            }
        }
    }
}
</style>
